import { CButton, CInput, CInputGroup, CInputGroupPrepend } from '@coreui/react';
import * as React from 'react';
import { IPlay } from '../abstraction';
import imgPlay from '../img/right.png';

interface IProps {
	code: string;
	player: IPlay;
}

// Affiche un controle permettant de lancer la lecture d'un son
export class KSoundPlayer extends React.Component<IProps> {
	public constructor(props: any) {
		super(props);
	}

	onClick = () => {
		if (this.props.player) {
			this.props.player.play(this.props.code);
		}
	}

	render() {
		return (
			<CInputGroup className="KSoundPlayer">
				<CInputGroupPrepend ><CButton onClick={this.onClick} ><img src={imgPlay} /></CButton></CInputGroupPrepend>
				<CInput readOnly value={this.props.code} />
			</CInputGroup>
		)
	}
}